import { css } from '@emotion/react';
import '@fontsource/open-sans';

let font = require('../media/Square.ttf');

export enum Font {
  Special = "'square', sans-serif",
  Normal = "'Open Sans', sans-serif"
}

export const SquareFont = css`
  @font-face {
    font-family: square;
    src: url(${font});
  }
`;
